export default __webpack_public_path__ + "static/tenancy-management-dc81a13b84104828675fd8b645e66cea.svg";